import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import { CgvService } from './cgv.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-cgv',
  templateUrl: './cgv.component.html',
  styleUrls: ['./cgv.component.scss'],
})
export class CgvComponent {
  @ViewChild('scrollableContent', { static: false }) scrollableContent!: ElementRef;
  scrolledToBottom = false;
  isAccepted = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private cgvService: CgvService,
              private dialogRef: MatDialogRef<CgvComponent>) {
    this.cgvService.resetCGV();
    this.isAccepted = data.isAccepted;
  }

  onScroll(event: Event): void {
    const element = event.target as HTMLElement;

    const atBottom = Math.ceil(element.scrollTop + element.clientHeight) >= (element.scrollHeight - 30);
    this.scrolledToBottom = atBottom;

    console.log('scrolledToBottom:', this.scrolledToBottom);
  }

  acceptCGV(): void {
    // this.cgvService.acceptCGV();
    this.dialogRef.close(true);
  }
}
